module.exports = __webpack_public_path__ + "static/media/map_ferit.1577ce84.png";